import type { CookieOptions } from '@packages/shared/src/providers/CookieProvider/CookieProvider';

/**
 * Attributes for cookies written in the browser, per the cookie standard (ADR general/003-cookie-standard):
 * host-only (no `domain`), `Path=/`, `Secure`, `SameSite=Lax`. They are readable from JavaScript, the
 * standard's documented exception to `HttpOnly`, because client code writes and reads them.
 */
export const clientCookieOptions = {
  path: '/',
  secure: true,
  sameSite: 'lax',
} as const satisfies CookieOptions;
